import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  wallet: any = 0;
  logo: any = '';
  name: any = '';

  private walletSubject = new BehaviorSubject<any>(null);
  private logoSubject = new BehaviorSubject<any>(null)
  private nameSubject = new BehaviorSubject<any>(null)
  
  walletSubject$ = this.walletSubject.asObservable();
  logoSubject$ = this.logoSubject.asObservable()
  nameSubject$ = this.nameSubject.asObservable()

  constructor(private http: HttpClient) { }

  walletAmount(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/admin/wallet`, payload)
  }

  profileDetails(): Observable<any> {
    return this.http.get<any>(`${environment.apiURL}/admin/user/details`);
  }

  adminProfileDetails() {
    this.profileDetails().subscribe((res: any) => {
      if (res.success) {
        this.wallet = res.admin.wallet;
        this.name = res.admin.name;
        this.logo = res.admin.logo;
        this.walletSubject.next(this.wallet);
        this.logoSubject.next(this.logo);
        this.nameSubject.next(this.name)
      }
    })
  }

}
